import ver2 from './ver2'

export default {
  ver2
}



// WEBPACK FOOTER //
// ./src/components/V2/index.js